<template>
  <div class="lightgrayBG selectWallet">
	<div class="row ">
		<alert-notification v-if="notification_msg != '' && !showPopup" />
        <loader v-if="pageLoader && !showPopup" />
	    <div class="col-12 col-lg-7">
	      <div class="cap_exhange_cur w-100 px-0">
	        <div class="walletBlock position-relative">
	          <label class="mb-2">Choose Wallet</label>
	          <div @click.stop="showCurr = !showCurr">
	            <div class="dropdown cap_fund cur_ico">
	              <button class="border bg-white cap_btn dropdown-toggle px-3" type="button">
	                <img class="cp__ico" :src="
	                    '../../../../static/website/images/crypto_logos/' +
	                    selected_currency.toLowerCase() +
	                    '.png'
	                  " alt="" @error="handleImgErr($event)" v-if="
	                    selected_currency != '' && checkImage(selected_currency)
	                  " />
	                <span class="firstName" v-else-if="selected_currency != ''">{{
	                  selected_currency.charAt(0)
	                  }}</span>
	                {{ selected_currency || "Select Currency" }}
	              </button>
	            </div>
	          </div>
	          <div class="dropdown-menu rounded" :class="showCurr ? 'show' : ''">
	            <div class="cur_search showCurr">
	              <input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchCurr" id="searchCurr"
	                autocomplete="off" />
	            </div>
	            <div class="scrolling_text">
	              <table class="table table-striped">
	                <tbody v-if="withDepoCurList.length > 0">
	                  <tr class="pointer" v-for="value in marginList()" @click.prevent="
	                      selected_currency = value.symbol;
	                      searchCurr = '';
	                    " :class="value.symbol == selected_currency ? 'active' : ''">
	                    <td>
	                      <span class="d-flex align-items-center icNmae">
	                        <img :src="
	                            '../../../../static/website/images/crypto_logos/' +
	                            value.symbol.toLowerCase() +
	                            '.png'
	                          " @error="handleImgErr($event)" v-if="checkImage(value.symbol)" />
	                        <span class="firstName" v-else>{{
	                          value.symbol.charAt(0)
	                          }}</span>
                          <span class="muted semibold" v-if="$env_var.restricted_currencies.hasOwnProperty(value.symbol)">
                            <span>{{ $env_var.restricted_currencies[value.symbol].currency_name}}</span>
                            <span class="fullName">{{value.currency_name}}</span>
                          </span>
	                        <span class="muted semibold" v-else>
                            <span>{{ value.symbol}}</span>
                            <span class="fullName">{{
	                            value.currency_name
	                            }}</span></span>
	                      </span>
	                    </td>
	                    <td align="right">
	                      <span class="f-16 d-block">{{
	                        formatfloat(value.amount) || 0
	                        }}</span>
	                    </td>
	                  </tr>
	                </tbody>
	              </table>
	            </div>
	          </div>
	          <p class="themecolor text-right mt-2 w-100">
	            Current Balance: {{ currentBal }} {{ selected_currency }}
	          </p>
	        </div>
	        <div class="walletBlock position-relative mb-4">
	          <label class="mb-2">Withdraw Amount</label>
	          <div class="position-relative p-0 form-group mb-0">
	            <input type="text" class="form-control copyCode" autocomplete="off" name="amount" required=""
	              placeholder="Enter Amount" v-model="withdraw_amount" v-validate="{
	                required: true,
	                decimal: 8,
	                max_value: currentBal,
	                regex: /^(?=.*[1-9])\d+(\.\d+)?$/,
	              }" />
	            <span class="copyBtn position-absolute topRT">{{
	              selected_currency
	              }}</span>
	          </div>
	          <span v-if="submitted && errors.has('amount')" class="text-danger">{{ errors.first("amount") }}</span>
	        </div>
	        <div class="walletBlock position-relative mb-4">
	          <label class="mb-2">Verify Crypto Address</label>
	          <div class="position-relative p-0">
	            <input type="text" class="form-control copyCode" autocomplete="off" name="addess" required=""
	              placeholder="Enter Crypto Address" v-model="crypto_addess" v-validate="'required'" />
	            
	          </div>
	          <span v-if="submitted && errors.has('amount')" class="text-danger">{{
	            errors.first("amount").includes("format is invalid")
	            ? "Amount should be greater than 0"
	            : errors.first("amount")
	            }}</span>
	          
	        </div>
	      </div>
	    </div>
	    <div class="col-12 col-lg-5">
	      <div class="transactionDetails">
	        <label class="medium mb-2">Transaction Details:</label>
	        <div class="transactionElement border bg-white">
	          <div class="transactionFees border-bottom mb-3">
	            <p class="mb-2 themecolor semibold">Transaction Fees</p>
	            <p class="f-14 themecolor" v-if="
	                getkeyType(selected_currency) == 'ERC20' &&
	                selected_currency != 'ETH'
	              ">
	              {{
	              withdraw_amount
	              ? numberFormat(21000 * withdraw_amount * 0.00000002)
	              : "0"
	              }}
	              ETH
	            </p>
	            <p class="f-14 themecolor" v-else>
	              {{
	              withdraw_amount
	              ? numberFormat((withdraw_amount / 100) * 0.5)
	              : "0"
	              }}
	              {{ selected_currency }}
	            </p>
	          </div>
	          <div class="transactionFees border-bottom mb-3">
	            <p class="mb-2 themecolor semibold">Total Withdrawal</p>
	            <p class="f-14 themecolor">
	              {{
	              withdraw_amount
	              ? withdraw_amount - (withdraw_amount / 100) * 0.5
	              : "0"
	              }}
	              {{ selected_currency }}
	            </p>
	          </div>
	        </div>
	      </div>
	    </div>
	    
	    <div class="col-12 text-center mt-4 mt-md-5">
	      <a href="javascript:void(0)" class="cap_btn secondaryBG lg min-250" data-toggle="modal"
	        data-target="#exampleModalCenter" @click="checkWithdraw()">Review Withdrawal</a>
	    </div>
  	</div>
  </div>

</template>
<script>
  import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
  import tradingMixins from "@/plugins/trading";
  import { Const } from "@/plugins/vue-provider-cache/const.mod";
  import math from "../../../../static/website/js/math.js";
  import fiatWithdrawalSection from "./withdrawal-fiat"
  import cryptoWithdrawalSection from "./withdrawal-crypto"
  export default {
    name: "deposit-section",
    mixins: [depositWithdrawalMixins, tradingMixins],
    data() {
      return {
        taskTab: "cryptoWithdrawal",
        pageLoader: false,
        notification_msg: "",
        notification_type: "",
        errImage: [],
        submitted: false,
        isCrypto: true,
        allowfiat: true,
        step: "1",
        notCryptoCurrency: ['EURO', 'USD', 'AUD', 'GBP', 'JPY'],
        margin_list: {},
        showCurr: false,
        selected_currency: "BTC",
        searchCurr: "",

        withdraw_amount: "",
        crypto_addess: "",

        crypto: false,

        page: "1",
        pageLimit: "10",

        transaction_id: "",
        otp: "",
        success: false,
        showPopup: false,
      };
    },
    components: {
      fiatWithdrawalSection, cryptoWithdrawalSection
    },
    computed: {
      currentBal() {
        try {
          return Object.values(this.margin_list).filter(
            (val) =>
              this.selected_currency == val.currency && parseFloat(val.amount) > 0
          )[0].amount;
        } catch (e) {
          return 0;
        }
      },
    },
    watch: {
      tradingAccount(value) {
        this.getCurrency(value);
        this.listing(value);
      },
    },
    methods: {
      // getBankDetails() {alert()
      //       let json = {
      //           globalParams: {},
      //           localParams: { parameter: this },
      //       }
      //       this._runGetBankDetails(json);
      //   },
      withdrawal_req_otp_check() {
        if (this.pageLoader) {
          return;
        }
        const _that = this;
        _that.submitted = true;
        _that.$validator.validate().then((valid) => {
          if (valid) {
            this._runWithdrawalCheckOtp({
              globalParams: {
                trans_id: _that.transaction_id,
                otp: _that.otp,
                verify: "",
              },
              localParams: { parameter: this },
            });
          }
        });
      },
      checkWithdraw() {
        var account_id = "";
        this.tradingAccount[0].subAccounts.forEach((value) => {
          if (this.selected_currency == value.currency) {
            account_id = value.act_account_id;
          }
        });
        if (account_id == "") {
          this.notification_msg = "error";
          this.notification_type =
            this.selected_currency +
            " currency has no available balance to withdraw.";
          setTimeout(() => {
            this.notification_msg = "";
            this.notification_type = "";
          }, 5000);
          return;
        } else {
          const _that = this;
          _that.submitted = true;
          _that.$validator.validate().then((valid) => {
            if (valid) {
              _that.showPopup = true;
            }
          });
        }
      },
      withdrawal_req_otp() {
        if (this.pageLoader) {
          return;
        }
        var account_id = "";
        this.tradingAccount[0].subAccounts.forEach((value) => {
          if (this.selected_currency == value.currency) {
            account_id = value.act_account_id;
          }
        });
        if (account_id == "") {
          this.notification_msg = "error";
          this.notification_type =
            this.selected_currency +
            " currency has no available balance to withdraw.";
        }
        // console.log('withdrawalItem',this.selected_currency,this.tradingAccount[0].subAccounts)
        const _that = this;
        _that.submitted = true;
        _that.$validator.validate().then((valid) => {
          if (valid) {
            var inputJson = {
              globalParams: {
                account_id: _that.tradingAccount[0].account_id,
                act_account_id: account_id,
                amount: _that.withdraw_amount,
                address: _that.crypto_addess,
                crypto: _that.selected_currency,
                method_id: "",
                withdrawal_method: "",
              },
              localParams: { parameter: _that },
            };
            if (!this.isCrypto) {
              inputJson.globalParams.method_id = this.withdrawal_Bank.split('-')[0]
              inputJson.globalParams.withdrawal_method = this.withdrawal_Bank.split('-')[1]
            }
            console.log("inputJson---->", inputJson);
            this._runWithdrawalRequestOtp(inputJson);
          }
        });
      },
      getStatusClass(val) {
        try {
          return this.depositStatus[val].class || "";
        } catch (e) {
          return "";
        }
      },
      getStatus(val) {
        try {
          return this.depositStatus[val].name || "-";
        } catch (e) {
          return "-";
        }
      },
      listing(accounts) {
        this.withdrawalListing(accounts);
      },
      withdrawalListing(accounts) {
        if (accounts && accounts.length) {
          this._runGetWithdrawalList({
            globalParams: {
              filter: {
                "withdrawal.account_id": this.tradingAccount.length
                  ? `${this.tradingAccount[0].account_id}`
                  : "0",
              },
              sort: [],
              search: "",
              page: this.page,
              perPage: parseInt(this.pageLimit),
            },
            localParams: { parameter: this },
          });
        }
      },
      formatfloat(num) {
        if (num) {
          num = parseFloat(num);
          try {
            return math.format(num, { notation: "fixed" }) || "";
          } catch (e) {
            try {
              return num.toFixed(8);
            } catch (e) {
              return "";
            }
          }
        } else {
          return 0;
        }
      },
      checkImage(val) {
        return this.errImage.includes(val.toLowerCase()) ? false : true;
      },
      handleImgErr(val) {
        var fullSrc = val.target.src.split(".");
        var src = fullSrc[fullSrc.length - 2].split("/");
        var img = src[src.length - 1];
        if (!this.errImage.includes(img)) {
          this.errImage.push(img);
        }
      },
      marginList() {
        let returnData = [],
          notZero = [];
        for (const key1 in this.withDepoCurList) {
          let data = this.withDepoCurList[key1];
          if (!(this.notCryptoCurrency.includes(data.symbol.toUpperCase()))){
            
            for (const key in this.margin_list) {
              if (
                this.margin_list[key].currency == data.symbol &&
                parseFloat(this.margin_list[key].amount) > 0
              ) {
                data["amount"] = this.margin_list[key].amount;
              }
            }
            if (data["amount"] > 0) {
              notZero.push(data);
            } /*else{
                      returnData.push(data);
                  }*/
          }
        }
        var search = this.searchCurr.toLowerCase();
        return notZero.concat(returnData).filter((val) =>
          this.searchCurr ? val.symbol.toLowerCase().includes(search) ||  val.currency_name.toLowerCase().includes(search) : true
        );
      },
      subscribPairs(pairList) {
        try {
          if (pairList.length > 0) {
            this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
              "S_PF_PF"
            ].subscribe(pairList);
          }
        } catch (e) {
          setInterval(() => {
            this.subscribPairs(pairList);
          }, 1000);
        }
      },
      getCurrency(value) {
        if (value.length > 0 && value[0].subAccounts.length > 0) {
          let btcPair = value[0].subAccounts.map((val) => val.currency + "-BTC");
          let usdPair = value[0].subAccounts.map((val) => val.currency + "-USD");
          this.subscribPairs(btcPair.concat(usdPair));
          this._runGetMarginInfo({
            globalParams: { account_id: this.tradingAccount[0].account_id },
            localParams: { parameter: this, page: "withdrawal" },
          });
        }
      },
      downloadTransactions() {
        let headerCols = [],
          data = [],
          filename = "";
        filename = "withdrawals";
        headerCols = Object.keys(this.withdrawalList.records[0]);
        data = this.withdrawalList.records;
        this.csvExport(data, headerCols, filename);
      },
      csvExport(data, headers, filename) {
        let csvData = headers.join(", ").replace(/_/g, " ").toUpperCase();
        csvData += "\n";
        data.map((row) => {
          headers.map((i, index) => {
            if (index < headers.length - 1) {
              csvData += `${row[i]}, `;
            } else {
              csvData += `${row[i]}\n`;
            }
          });
        });
        var hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvData);
        hiddenElement.target = "_blank";
        hiddenElement.download = filename;
        hiddenElement.click();
      },
    },
    created() {
      if (this.$route.query.withdraw) {
        this.selected_currency = this.$route.query.withdraw;
      }
      this.getCurrency(this.tradingAccount);
      this.withdrawalListing(this.tradingAccount);
      this._runGetWithDepoCurList({
        globalParams: {},
        localParams: { parameter: this, 'link': true },
      });

      // this._runGetWithdrawalMethods({ 'globalParams' :{ },'localParams' :{"parameter" : this}})

      if (this.notCryptoCurrency.includes(this.selected_currency.toUpperCase())) {
        this.isCrypto = false
        // console.log(Object.values(this.$env_var.fiatAllowCountries))
        if (this.get_user.profile.country && Object.values(this.$env_var.fiatAllowCountries).includes(this.get_user.profile.country)) {
          this.allowfiat = true
        }
      }
    },
    updated() {
      if (this.showCurr) {
        document.getElementById("searchCurr").focus();
      }
    },
    mounted() {
      const _that = this;
      $(document).on("click", function (event) {
        if (!$(event.target).closest(".showCurr").length) {
          _that.showCurr = false;
        }
      });
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/withdrawal-crypto.vue